import React from "react";
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import API from "../../API";

const cityOptions = Object.values(API.allowedCities || {}).map((city) => ({
  label: city.name,
  value: city.id,
}));

const createDefaultValue = () => ({
  name: "",
  email: "",
  phone: "",
  address: "",
  contactName: "",
  city: "",
  credits: "",
  freeCredits: "",
  isCorporate: false,
  onlineKioskId: "",
  deactive: false,
});

const parseOptionalNumber = (value) => {
  if (value === "" || value === null || value === undefined) return undefined;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? undefined : parsed;
};

export default function BusinessFormDialog({
  open,
  business,
  saving,
  onClose,
  onSubmit,
}) {
  const [form, setForm] = React.useState(createDefaultValue());

  React.useEffect(() => {
    if (!open) return;

    setForm({
      ...createDefaultValue(),
      ...(business || {}),
      city: business?.city ?? "",
      credits: business?.credits ?? "",
      freeCredits: business?.freeCredits ?? "",
      onlineKioskId: business?.onlineKioskId ?? "",
    });
  }, [business, open]);

  const handleChange = (field, value) => {
    setForm((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = () => {
    if (!form.name?.trim()) {
      global.showPopup("Hata", "İşletme adı zorunludur.");
      return;
    }

    onSubmit({
      ...(business?._id ? { _id: business._id } : {}),
      name: form.name.trim(),
      email: form.email?.trim() || undefined,
      phone: form.phone?.trim() || undefined,
      address: form.address?.trim() || undefined,
      contactName: form.contactName?.trim() || undefined,
      city: parseOptionalNumber(form.city),
      credits: parseOptionalNumber(form.credits),
      freeCredits: parseOptionalNumber(form.freeCredits),
      isCorporate: Boolean(form.isCorporate),
      onlineKioskId: parseOptionalNumber(form.onlineKioskId),
      deactive: Boolean(form.deactive),
    });
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="md">
      <DialogTitle>
        {business?._id ? "İşletmeyi Düzenle" : "Yeni İşletme"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} md={6}>
            <TextField
              label="İşletme Adı"
              fullWidth
              required
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Yetkili Kişi"
              fullWidth
              value={form.contactName}
              onChange={(e) => handleChange("contactName", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="E-posta"
              fullWidth
              value={form.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Telefon"
              fullWidth
              value={form.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Adres"
              fullWidth
              multiline
              minRows={2}
              value={form.address}
              onChange={(e) => handleChange("address", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Şehir"
              fullWidth
              value={form.city}
              onChange={(e) => handleChange("city", e.target.value)}
            >
              <MenuItem value="">Seçiniz</MenuItem>
              {cityOptions.map((city) => (
                <MenuItem key={city.value} value={city.value}>
                  {city.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Credits"
              type="number"
              fullWidth
              value={form.credits}
              onChange={(e) => handleChange("credits", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              label="Free Credits"
              type="number"
              fullWidth
              value={form.freeCredits}
              onChange={(e) => handleChange("freeCredits", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Online Kiosk ID"
              type="number"
              fullWidth
              value={form.onlineKioskId}
              onChange={(e) => handleChange("onlineKioskId", e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ display: "flex", alignItems: "center" }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(form.isCorporate)}
                  onChange={(e) => handleChange("isCorporate", e.target.checked)}
                />
              }
              label="Kurumsal"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(form.deactive)}
                  onChange={(e) => handleChange("deactive", e.target.checked)}
                />
              }
              label="Pasif"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          İptal
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving}>
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
